import createMuiTheme from '@material-ui/core/styles/createMuiTheme';

import overrides from './overrides';
import props from './props';
import variables from './variables';

const primary = {
  main: '#FFBC00',
  contrastText: '#000000',
  light: '#78909C',
  dark: '',
  overrides,
};

const secondary = {
  light: '#ffffff',
  main: '#64B12F',
  contrastText: '#000000',
  dark: '#c79c00',
  overrides,
};

export const antdTheme = {
  token: {
    colorPrimary: '#FFBC00',
    colorSecondary: '#0D2772',
    colorTextLightSolid: '#000000',
    colorBgLayout: '#fcfcfc',
    colorBgTextHover: 'rgba(0, 0, 0, 0.03)',
    fontFamily: "'Roboto', sans-serif",
    fontSize: 16,
    borderRadius: 4,
  },
};

export const theme = createMuiTheme({
  palette: { primary, secondary },
  overrides,
  variables,
  props,
});

export const reverseTheme = createMuiTheme({
  palette: { primary: secondary, secondary: primary },
  overrides,
  variables,
  props,
});
